import { createContext, useContext } from "react";
import { MultiSelectActionsContext, MultiSelectContext } from "../MultiSelect/context/MultiSelectContext.js";
const SelectActionsContext = createContext(null), SelectContext = createContext(null), useSelectCommonActionsContext = () => {
  const ctx = useContext(SelectActionsContext), multi = useContext(MultiSelectActionsContext);
  return ctx ?? multi;
}, useSelectCommonContext = () => {
  const ctx = useContext(SelectContext), multi = useContext(MultiSelectContext);
  return ctx ?? multi;
};
export {
  SelectActionsContext,
  SelectContext,
  useSelectCommonActionsContext,
  useSelectCommonContext
};
//# sourceMappingURL=SelectContext.js.map
